import PushNotificationProvider from './PushNotificationProvider';

export default PushNotificationProvider;
